import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_760bccdc from 'nuxt_plugin_sentryserver_760bccdc' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_10525b54 from 'nuxt_plugin_sentryclient_10525b54' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_1ea114c0 from 'nuxt_plugin_cookieuniversalnuxt_1ea114c0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_65a4a518 from 'nuxt_plugin_axios_65a4a518' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_81e4c7ba from 'nuxt_plugin_pluginutils_81e4c7ba' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2fd0a6a4 from 'nuxt_plugin_pluginrouting_2fd0a6a4' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_785a2d81 from 'nuxt_plugin_pluginmain_785a2d81' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_image_50aba213 from 'nuxt_plugin_image_50aba213' // Source: ./image.js (mode: 'all')
import nuxt_plugin_lazySizes_51668b90 from 'nuxt_plugin_lazySizes_51668b90' // Source: ./lazySizes.js (mode: 'all')
import nuxt_plugin_gsapModule_21555739 from 'nuxt_plugin_gsapModule_21555739' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_fontLoader_2478547e from 'nuxt_plugin_fontLoader_2478547e' // Source: ./fontLoader.js (mode: 'client')
import nuxt_plugin_deviceplugin_cf9cb6ba from 'nuxt_plugin_deviceplugin_cf9cb6ba' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_a33e6e76 from 'nuxt_plugin_dayjsplugin_a33e6e76' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_locale_28023ea7 from 'nuxt_plugin_locale_28023ea7' // Source: ../plugins/locale.js (mode: 'all')
import nuxt_plugin_locomotiveScrollclient_4d8b80f6 from 'nuxt_plugin_locomotiveScrollclient_4d8b80f6' // Source: ../plugins/locomotiveScroll.client.js (mode: 'client')
import nuxt_plugin_routeredirects_1be7457a from 'nuxt_plugin_routeredirects_1be7457a' // Source: ../plugins/route-redirects.js (mode: 'all')
import nuxt_plugin_pagetransition_6814308c from 'nuxt_plugin_pagetransition_6814308c' // Source: ../plugins/page-transition.js (mode: 'all')
import nuxt_plugin_breadcrumbs_eda567c6 from 'nuxt_plugin_breadcrumbs_eda567c6' // Source: ../plugins/breadcrumbs.js (mode: 'all')
import nuxt_plugin_ensureArrayclient_27d689ba from 'nuxt_plugin_ensureArrayclient_27d689ba' // Source: ../plugins/ensureArray.client.js (mode: 'client')
import nuxt_plugin_axiosinterseptor_4a743f22 from 'nuxt_plugin_axiosinterseptor_4a743f22' // Source: ../plugins/axios-interseptor.js (mode: 'all')
import nuxt_plugin_portalclient_3222e2c0 from 'nuxt_plugin_portalclient_3222e2c0' // Source: ../plugins/portal.client.js (mode: 'client')
import nuxt_plugin_swiperclient_d2033868 from 'nuxt_plugin_swiperclient_d2033868' // Source: ../plugins/swiper.client.js (mode: 'client')
import nuxt_plugin_vuetelinputclient_620c2879 from 'nuxt_plugin_vuetelinputclient_620c2879' // Source: ../plugins/vue-tel-input.client.js (mode: 'client')
import nuxt_plugin_ymapPlugin_43baa32b from 'nuxt_plugin_ymapPlugin_43baa32b' // Source: ../plugins/ymapPlugin.js (mode: 'client')
import nuxt_plugin_yclients_62f7d2f2 from 'nuxt_plugin_yclients_62f7d2f2' // Source: ../plugins/yclients.js (mode: 'client')
import nuxt_plugin_swipedeventsclient_348af684 from 'nuxt_plugin_swipedeventsclient_348af684' // Source: ../plugins/swiped-events.client.js (mode: 'client')
import nuxt_plugin_scaledisableclient_28fb4ccd from 'nuxt_plugin_scaledisableclient_28fb4ccd' // Source: ../plugins/scale-disable.client.js (mode: 'client')
import nuxt_plugin_metrika_666ceba4 from 'nuxt_plugin_metrika_666ceba4' // Source: ../plugins/metrika.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"css":false,"enter":function(el, done) {
      this.$store.dispatch('resourceLoader/watchResourcesLoad');
      if (!this.$store.getters['resourceLoader/preloading']) {
        this.$store.dispatch('pageTransition/enter').then(done);
      } else {
        const unwatch = this.$store.watch(
        (_, getters) => getters['resourceLoader/preloading'],
        () => {
          unwatch();
          this.$store.dispatch('pageTransition/enter').then(done);
        });
      }
    },"afterEnter":function() {
      this.$store.dispatch('pageTransition/toDefault');
    },"leave":function(el, done) {
      this.$store.dispatch('pageTransition/leave').then(done);
    },"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en-US"},"title":null,"titleTemplate":null,"script":[{"src":"https:\u002F\u002Fw214622.yclients.com\u002FwidgetJS","body":true},{"innerHTML":"(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; var z = null;m[i].l=1*new Date();for (var j = 0; j \u003C document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }} k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) (window, document, \"script\", \"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js\", \"ym\"); ym(37069155, \"init\", { clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true, trackHash:true });"},{"innerHTML":"!function(){var t=document.createElement(\"script\");t.type=\"text\u002Fjavascript\",t.async=!0,t.src='https:\u002F\u002Fvk.com\u002Fjs\u002Fapi\u002Fopenapi.js?169',t.onload=function(){VK.Retargeting.Init(\"VK-RTRG-1497133-au1Bv\"),VK.Retargeting.Hit()},document.head.appendChild(t)}();"},{"innerHTML":"var _tmr = window._tmr || (window._tmr = []);\n_tmr.push({id: \"3277472\", type: \"pageView\", start: (new Date()).getTime()});\n(function (d, w, id) {\nif (d.getElementById(id)) return;\nvar ts = d.createElement(\"script\"); ts.type = \"text\u002Fjavascript\"; ts.async = true; ts.id = id;\nts.src = \"https:\u002F\u002Ftop-fwz1.mail.ru\u002Fjs\u002Fcode.js\";\nvar f = function () {var s = d.getElementsByTagName(\"script\")[0]; s.parentNode.insertBefore(ts, s);};\nif (w.opera == \"[object Opera]\") { d.addEventListener(\"DOMContentLoaded\", f, false); } else { f(); }\n})(document, window, \"tmr-code\");"},{"innerHTML":"(function(w, d, s, h, id) {\n    w.roistatProjectId = id; w.roistatHost = h;\n    var p = d.location.protocol == \"https:\" ? \"https:\u002F\u002F\" : \"http:\u002F\u002F\";\n    var u = \u002F^.*roistat_visit=[^;]+(.*)?$\u002F.test(d.cookie) ? \"\u002Fdist\u002Fmodule.js\" : \"\u002Fapi\u002Fsite\u002F1.0\u002F\"+id+\"\u002Finit?referrer=\"+encodeURIComponent(d.location.href);\n    var js = d.createElement(s); js.charset=\"UTF-8\"; js.async = 1; js.src = p+h+u; var js2 = d.getElementsByTagName(s)[0]; js2.parentNode.insertBefore(js, js2);\n})(window, document, 'script', 'cloud.roistat.com', '1e2909682563b3c921e18928b03b177b');"}],"__dangerouslyDisableSanitizers":["script"],"meta":[{"hid":"charset","charset":"utf-8"},{"hid":"http-equiv","http-equiv":"X-UA-Compatible","content":"IE=edge"},{"hid":"viewport","name":"viewport","content":"width=device-width,initial-scale=1"},{"hid":"description","name":"description","content":"Encore Fitness — сеть фитнес-клубов премиум класса с бассейном и СПА. Красивые интерьеры, идеальные тренировочные пространства дополняются роскошным термальным комплексом, зонами для релакса и сервисом на пять звезд."},{"hid":"robots","name":"robots","content":"index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"font-preload","rel":"preload","as":"style","href":"\u002Ffonts\u002Ffont-face.css"}],"style":[],"noscript":[{"hid":"font-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"\u002Ffonts\u002Ffont-face.css\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"font-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_760bccdc === 'function') {
    await nuxt_plugin_sentryserver_760bccdc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_10525b54 === 'function') {
    await nuxt_plugin_sentryclient_10525b54(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1ea114c0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1ea114c0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_65a4a518 === 'function') {
    await nuxt_plugin_axios_65a4a518(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_81e4c7ba === 'function') {
    await nuxt_plugin_pluginutils_81e4c7ba(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2fd0a6a4 === 'function') {
    await nuxt_plugin_pluginrouting_2fd0a6a4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_785a2d81 === 'function') {
    await nuxt_plugin_pluginmain_785a2d81(app.context, inject)
  }

  if (typeof nuxt_plugin_image_50aba213 === 'function') {
    await nuxt_plugin_image_50aba213(app.context, inject)
  }

  if (typeof nuxt_plugin_lazySizes_51668b90 === 'function') {
    await nuxt_plugin_lazySizes_51668b90(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_21555739 === 'function') {
    await nuxt_plugin_gsapModule_21555739(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontLoader_2478547e === 'function') {
    await nuxt_plugin_fontLoader_2478547e(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_cf9cb6ba === 'function') {
    await nuxt_plugin_deviceplugin_cf9cb6ba(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_a33e6e76 === 'function') {
    await nuxt_plugin_dayjsplugin_a33e6e76(app.context, inject)
  }

  if (typeof nuxt_plugin_locale_28023ea7 === 'function') {
    await nuxt_plugin_locale_28023ea7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_locomotiveScrollclient_4d8b80f6 === 'function') {
    await nuxt_plugin_locomotiveScrollclient_4d8b80f6(app.context, inject)
  }

  if (typeof nuxt_plugin_routeredirects_1be7457a === 'function') {
    await nuxt_plugin_routeredirects_1be7457a(app.context, inject)
  }

  if (typeof nuxt_plugin_pagetransition_6814308c === 'function') {
    await nuxt_plugin_pagetransition_6814308c(app.context, inject)
  }

  if (typeof nuxt_plugin_breadcrumbs_eda567c6 === 'function') {
    await nuxt_plugin_breadcrumbs_eda567c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ensureArrayclient_27d689ba === 'function') {
    await nuxt_plugin_ensureArrayclient_27d689ba(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosinterseptor_4a743f22 === 'function') {
    await nuxt_plugin_axiosinterseptor_4a743f22(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalclient_3222e2c0 === 'function') {
    await nuxt_plugin_portalclient_3222e2c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiperclient_d2033868 === 'function') {
    await nuxt_plugin_swiperclient_d2033868(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinputclient_620c2879 === 'function') {
    await nuxt_plugin_vuetelinputclient_620c2879(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ymapPlugin_43baa32b === 'function') {
    await nuxt_plugin_ymapPlugin_43baa32b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yclients_62f7d2f2 === 'function') {
    await nuxt_plugin_yclients_62f7d2f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swipedeventsclient_348af684 === 'function') {
    await nuxt_plugin_swipedeventsclient_348af684(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scaledisableclient_28fb4ccd === 'function') {
    await nuxt_plugin_scaledisableclient_28fb4ccd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metrika_666ceba4 === 'function') {
    await nuxt_plugin_metrika_666ceba4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
